import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment.dev';
import { NewsletterSubscribeResponse, NewsletterSubscriber } from '../../shared/models/system';
import { SpringPage } from '../../shared/models/page';

export interface NewsletterSubscribePayload {
  email: string;
  optIn: boolean;
  source?: string;
}

@Injectable({ providedIn: 'root' })
export class NewsletterService {
  private apiUrl = `${environment.apiUrl}/newsletter`;

  constructor(private http: HttpClient) {}

  subscribe(payload: NewsletterSubscribePayload): Observable<NewsletterSubscribeResponse> {
    return this.http.post<NewsletterSubscribeResponse>(`${this.apiUrl}/subscribe`, payload);
  }

  list(page = 0, size = 10, q?: string): Observable<SpringPage<NewsletterSubscriber>> {
    let params = new HttpParams()
      .set('page', String(page))
      .set('size', String(size));
    if (q?.trim()) params = params.set('q', q.trim());
    return this.http.get<SpringPage<NewsletterSubscriber>>(this.apiUrl, { params });
  }
}